export default "/images/petrolimex_logo.webp?353899e28a63a6725e21d6389680dec4";